import {ReactNode} from 'react';
import css from './Page.module.scss';
export type PageProps = {
  title: ReactNode;
  children: ReactNode;
};

export const Page = (props: PageProps) => {
  return (
    <div className={css.root}>
      <h1 className={css.header}>{props.title}</h1>
      <div className={css.content}>{props.children}</div>
    </div>
  );
};
